module.exports = __webpack_public_path__ + "img/biaozhun.b213cba8.svg";